import React from 'react'
import { ReferenceValue } from './ReferenceValue'
import { Container } from './styles'
import { checkboxWithLabel } from '../Checkbox'
import { Complement } from '../Complement'
import { isLaboratoryTestPropertyAltered } from '~/utils/laboratoryTest'

const EMPTY = ''

interface IQuantitativePropertyProps {
  id: number
  name: string
  sample: string
  value: string | number
  prefix?: string
  unit?: string
  lowerReferenceValue?: number
  upperReferenceValue?: number
  interpretation?: string
  complement?: string
  onChange: (property: { name: string; isSelected: boolean; id: number; sample: string }) => void
  selected: boolean
}

export const QuantitativeProperty: React.FC<IQuantitativePropertyProps> = (
  props: IQuantitativePropertyProps
): JSX.Element => {
  const {
    id,
    sample,
    name,
    prefix,
    value,
    unit,
    lowerReferenceValue,
    upperReferenceValue,
    interpretation,
    complement,
    onChange,
    selected
  } = props

  const handleOnChange = (property: { value: string; checked: boolean }) => {
    const { value: name, checked: isSelected } = property
    if (onChange) onChange({ name, isSelected, id, sample })
  }

  return (
    <Container>
      {checkboxWithLabel(isLaboratoryTestPropertyAltered(interpretation))({
        label: `${name.trim()}: ${prefix ?? EMPTY}${value}${unit ?? EMPTY}`,
        value: name,
        checked: selected,
        onChange: handleOnChange
      })}

      <ReferenceValue lowerValue={lowerReferenceValue} upperValue={upperReferenceValue} />

      <Complement text={complement ?? EMPTY} />
    </Container>
  )
}
